import cn from 'classnames';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_NAMES, LANGUAGES, type Language, saveLanguage } from 'src/lib/i18n/language';
import style from './LanguageSwitch.module.scss';

export const LanguageSwitch: FunctionComponent = () => {
  const { t, i18n } = useTranslation();

  const choose = (language: Language) => {
    saveLanguage(language);
    void i18n.changeLanguage(language);
  };

  return (
    <fieldset aria-label={t('language.label')} className={style.switch}>
      {LANGUAGES.map((language) => {
        const current = i18n.resolvedLanguage === language;

        return (
          <button
            key={language}
            type="button"
            lang={language}
            aria-label={LANGUAGE_NAMES[language]}
            aria-pressed={current}
            className={cn(style.option, { [style.current]: current })}
            onClick={() => choose(language)}
          >
            {language}
          </button>
        );
      })}
    </fieldset>
  );
};
